import { render } from "./PachongAdmin.vue?vue&type=template&id=0d83acea&scoped=true"
import script from "./PachongAdmin.vue?vue&type=script&lang=js"
export * from "./PachongAdmin.vue?vue&type=script&lang=js"

import "./PachongAdmin.vue?vue&type=style&index=0&id=0d83acea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d83acea"]])

export default __exports__